import React from "react";
import Logo from "../../components/Logo/Logo";
import "./Footer.css";
import { footer } from "../../data";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="overlay__div">
        <div className="container">
          <div className="column">
            <Logo />
            <p>
              Our mission is to create enduring spaces that inspire and elevate,
              delivering quality craftsmanship and innovative solutions tailored
              to the evolving needs of our clients and communities.
            </p>
          </div>
          {footer.map((foot, index) => (
            <div className="column" key={index}>
              <h4 className="title">{foot.title}</h4>
              {foot.routes.map((route, index) => (
                <a href={route.href} className="route" key={index}>
                  {route.name}
                </a>
              ))}
            </div>
          ))}
        </div>
        <div className="footer__bottom">
          <p>
            Copyright &copy; {new Date().getFullYear()} Prima Consultancy &
            Constructions - All rights reserved | Built by{" "}
            <a
              href="https://www.linkedin.com/company/webmosaicventures/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Webmosaic Ventures
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
